{
  "satis_urun_komisyon": {
    "Baslik": "Product Commissions",
    "Unvan": "Title",
    "Min Tutar": "Min Amount",
    "Max Tutar": "Max Amount",
    "Komisyon": "Commission",
    "Komisyon SM": "Commission SM",
    "Durum": "Status",
    "Ekle": "Add Commission",
    "Duzenle": "Edit",
    "Sil": "Delete",
    "Kaydet": "Save",
    "Guncelle": "Update",
    "Vazgec": "Cancel",
    "Aktif": "Active",
    "Pasif": "Passive",
    "Islemler": "İşlemler",
    "Yenile": "Yenile",
    "Urun": "Ürün"
  }
}
